import { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import SessionHistoryTable from "./components/table";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import api from "../../services/api";

const SessionsHistory = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalPages, setTotalPages] = useState(1); // optional if API provides it

  const fetchSessionsHistory = async () => {
    try {
      setLoading(true);
      const { data: apiData } = await api.get(
        `/offerslots/?page=${pageNo}`
      );
      setData(apiData?.data || []);
      setTotalPages(apiData?.totalPages || 1); // adjust based on your API response
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSessionsHistory();
  }, [pageNo]);

  const handlePrev = () => {
    if (pageNo > 1) setPageNo((prev) => prev - 1);
  };

  const handleNext = () => {
    if (pageNo < totalPages) setPageNo((prev) => prev + 1);
  };

  return (
    <Layout>
      <div className="row text-start">
        <h3 className="h3">Session's History</h3>
      </div>

      <div className="mt-4 col-12 mx-auto shadow border rounded px-2 py-2">
        <SessionHistoryTable loading={loading} data={data} />
      </div>

      <div className="row d-flex flex-row justify-content-end items-end my-3">
        <div className="d-flex align-items-end gap-2">
          <FaChevronLeft
            size={24}
            onClick={handlePrev}
            style={{
              cursor: pageNo > 1 ? "pointer" : "not-allowed",
              opacity: pageNo > 1 ? 1 : 0.5,
            }}
          />
          <span>Page {pageNo}</span>
          <FaChevronRight
            size={24}
            onClick={handleNext}
            style={{
              cursor: pageNo < totalPages ? "pointer" : "not-allowed",
              opacity: pageNo < totalPages ? 1 : 0.5,
            }}
          />
        </div>
      </div>
    </Layout>
  );
};

export default SessionsHistory;
